import Page from "../pages/layout/espFramePage";

export default [
  {
    path: "/pub_brand",
    name: "pub_brand",
    redirect: "/pub_brand/index",
    component: Page,
    children: [
      {
        path: "index",
        name: "pub_brand_index",
        meta: {title: "品牌管理", isIndex: true, keepAlive: true},
        component: () => import("@/pages/pub/brand/index")
      }
    ]
  },
  {
    path: "/pub_actag",
    name: "pub_actag",
    redirect: "/pub_actag/index",
    component: Page,
    children: [
      {
        path: "index",
        name: "pub_actag_index",
        meta: {title: "演员标签", isIndex: true, keepAlive: true},
        component: () => import("@/pages/pub/actag/index")
      }
    ]
  },
  {
    path: "/pub_actor",
    name: "pub_actor",
    redirect: "/pub_actor/index",
    component: Page,
    children: [
      {
        path: "index",
        name: "pub_actor_index",
        meta: {title: "演员", isIndex: true, keepAlive: true},
        component: () => import("@/pages/pub/actor/index")
      }
    ]
  },
  {
    path: "/pub_theatre",
    name: "pub_theatre",
    redirect: "/pub_theatre/index",
    component: Page,
    children: [
      {
        path: "index",
        name: "pub_theatre_index",
        meta: {title: "剧本", isIndex: true, keepAlive: true},
        component: () => import("@/pages/pub/theatre/index")
      }
    ]
  },
  {
    path: "/pub_theatreType",
    name: "pub_theatreType",
    redirect: "/pub_theatreType/index",
    component: Page,
    children: [
      {
        path: "index",
        name: "pub_theatreType_index",
        meta: {title: "剧本类型", isIndex: true, keepAlive: true},
        component: () => import("@/pages/pub/theatreType/index")
      }
    ]
  },
  {
    path: "/pub_sku",
    name: "pub_sku",
    redirect: "/pub_sku/index",
    component: Page,
    children: [
      {
        path: "index",
        name: "pub_sku_index",
        meta: {title: "商品表", isIndex: true, keepAlive: true},
        component: () => import("@/pages/pub/sku/index")
      }
    ]
  }

]



// WEBPACK FOOTER //
// ./src/router/pub.js